var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "",
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        title: _vm.$t("Clearing.ProvisionReview"),
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "90px",
                "label-position": "left"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.ProvisionDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "251px" },
                        attrs: {
                          no: "ProvisionDate",
                          type: "date",
                          clearable: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { no: "Confirm", type: "primary", size: "mini" } },
            [_vm._v(_vm._s(_vm.$t("Clearing.Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel", size: "mini" },
              on: { click: _vm.cancel }
            },
            [_vm._v(_vm._s(_vm.$t("Clearing.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }